import React, { useEffect } from "react";
import LoginForm from "../../components/LoginForm";
import { useNavigate } from "react-router-dom";
import "./index.css"

//FC function
const Login: React.FC = () => {
    const navigate = useNavigate()
    useEffect(() => {
        if (sessionStorage.getItem("isLogin") === '1') {
            navigate("/home")
        }
    }, [])
    return (
        <div className="login-page">
            <LoginForm></LoginForm>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none' }}>
                京ICP备2024073807号
            </a>
        </div>

    )
}
export default Login
